import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const UpdateForm = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    Title: '',
    Text: '',
    Url: '',
    Functions: [],
    Roles: [],
    Schools: [],
    Creator: '',
    LastShowDate: '',
    Status: false,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updated, setUpdated] = useState(false);

  
  const functionsList = [
    { value: "Dashboard", label: "Dashboard (startsida)" },
    { value: "Undervisningsgrupp", label: "Undervisningsgrupp" },
    { value: "Mentorsöversikt", label: "Mentorsöversikt" },
    { value: "Händelser", label: "Händelser" },
    { value: "Meddelanden", label: "Meddelanden" },
    { value: "Möten/utvecklingssamtal", label: "Möten/utvecklingssamtal" },
    { value: "Inlägg", label: "Inlägg" },
    { value: "Bokmärken", label: "Bokmärken" },
    { value: "Planeringar", label: "Planeringar" },
    { value: "Uppgifter", label: "Uppgifter" },
    { value: "Schema", label: "Schema" },
    { value: "Omdömen", label: "Omdömen" },
    { value: "Formulärmallar", label: "Formulärmallar" },
    { value: "Frånvaro", label: "Frånvaro" },
    { value: "Orapporterade lektioner", label: "Orapporterade lektioner" },
    { value: "Läroplaner", label: "Läroplaner" },
    { value: "Rapporterade meddelanden", label: "Rapporterade meddelanden" },
    { value: "Grupper", label: "Grupper" },
    { value: "Admin", label: "Admin" },
    { value: "Utvecklingsöversikt", label: "Utvecklingsöversikt (elev)" },
    { value: "Elevkort", label: "Elevkort (Personal)" }
  ];

  const rolesList = [
    { value: "Vårdnadshavare", label: "Vårdnadshavare" },
    { value: "Lärare", label: "Lärare" },
    { value: "Mentor", label: "Mentor" },
    { value: "Elev", label: "Elev" },
    { value: "Skolledare", label: "Skolledare" },
    { value: "Övergripande", label: "Övergripande" },
    { value: "Specialpedagog", label: "Specialpedagog" },
    { value: "Verksamhetschef", label: "Verksamhetschef" },
    { value: "Skoladministratör", label: "Skoladministratör" },
    { value: "SMS-administratör", label: "SMS-administratör" },
    { value: "Övrig personal", label: "Övrig personal" },
    { value: "Systemadministratör", label: "Systemadministratör" },
    { value: "Läroplansadministratör", label: "Läroplansadministratör" },
    { value: "Konversationsadministratör", label: "Konversationsadministratör" }
  ];

  const schoolFormsList = [
    { value: "Förskola", label: "Förskola" },
    { value: "Grundskola", label: "Grundskola" },
    { value: "Gymnasieskola", label: "Gymnasieskola" },
    { value: "Anpassad gymnasieskola", label: "Anpassad gymnasieskola" },
    { value: "Vuxenutbildning", label: "Vuxenutbildning" },
    { value: "Sameskola", label: "Sameskola" },
    { value: "Specialskola", label: "Specialskola" },
    { value: "Svenska för invandrare", label: "Svenska för invandrare" }
  ];

  useEffect(() => {
    if (!id) {
      setError('ID saknas');
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://haldor-infoapp-test.azurewebsites.net/api/Information/${id}`);
        if (response.status === 200) {
          const result = await response.json();
          
           // Extrahera unika functionNames
          // const uniqueFunctions = [...new Set(result.relationships?.map(r => r.functionName) || [])];
          const uniqueRoles = [...new Set(result.relationships?.map(x => x.roleName) || [])]
          const uniqueSchools = [...new Set(result.relationships?.map(s => s.schoolName) || [])]
          const uniqueService = new Set(result.relationships?.map(s => s.serviceName) || "")
          const uniqueServiceString = Array.from(uniqueService).join(", ");
          
          setFormData({
            Title: result.title || '',
            Text: result.text || '',
            // Functions: uniqueFunctions, 
            Url: result.url || '',
            Roles: uniqueRoles,
            Schools: uniqueSchools,
            Creator: result.creator || '',
            LastShowDate: result.lastShowDate || '',
            Status: result.status,
            Service: uniqueServiceString,        
            ShowOnlyOnce: result.showOnlyOnce === undefined ? false : result.showOnlyOnce
          });
          
        } else {
          setError(`Fel: ${response.status}`);
        }
      } catch (err) {
        setError(`Fetch error: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'Status' ? value === 'true' : value,
    });
  };

  const handleAddItem = (key, value) => {
    if (!formData[key].includes(value) && value !== "") {
      setFormData({
        ...formData,
        [key]: [...formData[key], value],
      });
    }
  };

  const handleRemoveItem = (key, value) => {
    setFormData({
      ...formData,
      [key]: formData[key].filter(item => item !== value),
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formattedData = {
      ...formData
      
    };
    
    const response = await fetch(`https://localhost:7257/api/Information/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formattedData),
    });

    if (response.ok) {
      setUpdated(true);
    } else {
      console.error('Uppdatering misslyckades');
    }
  };

  if (loading) return <div>Laddar...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="views">
      <h1>UPPDATERA</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="Title">Rubrik*</label>
          <input type="text" id="Title" name="Title" value={formData.Title} onChange={handleInputChange} required />
        </div>

        <div>
          <label htmlFor="Text">Beskrivning*</label>
          <textarea id="Text" name="Text" value={formData.Text} onChange={handleInputChange} required />
        </div>
        <div>
          <label htmlFor="Url">Länk</label>
          <input type='text' id="Url" name="Url" value={formData.Url} onChange={handleInputChange} />
        </div>
        {/* <div>
          <label htmlFor="Functions">Var ska informationen visas?*</label>
          <select id="Functions" name="Functions" onChange={(e) => handleAddItem('Functions', e.target.value)}>
            <option value="">Välj funktion</option>
            {functionsList.map((func, index) => (
              <option key={index} value={func.value}>
                {func.label}
              </option>
            ))}
          </select>
        </div> */}

        {/* <div className="list-content">
          {formData.Functions.map((func, index) => (
            <div key={index} className='role' onClick={() => handleRemoveItem('Functions', func)}>{func} X</div>
          ))}
          
        </div> */}

        <div>
          <label htmlFor="Roles">Roller*</label>
          <select id="Roles" name="Roles" onChange={(e) => handleAddItem('Roles', e.target.value)}>
            <option value="">Välj roll</option>
            {rolesList.map((role, index) => (
              <option key={index} value={role.value}>
                {role.label}
              </option>
            ))}
          </select>
        </div>

        <div className="list-content">
          {formData.Roles.map((role, index) => (
            <div key={index} className='role' onClick={() => handleRemoveItem('Roles', role)}>{role} X</div>
          ))}
        </div>

        <div>
          <label htmlFor="Schools">Skolformer*</label>
          <select id="Schools" name="Schools" onChange={(e) => handleAddItem('Schools', e.target.value)}>
            <option value="">Välj skola</option>
            {schoolFormsList.map((school, index) => (
              <option key={index} value={school.value}>
                {school.label}
              </option>
            ))}
          </select>
        </div>

        <div className="list-content">
          {formData.Schools.map((school, index) => (
            <div key={index} className='role' onClick={() => handleRemoveItem('Schools', school)}>{school} X</div>
          ))}
        </div>

        <div>
          <label htmlFor="Creator">Författare*</label>
          <input type="text" id="Creator" name="Creator" value={formData.Creator} onChange={handleInputChange} required />
        </div>

        <div>
          <label htmlFor="LastShowDate">Giltigt till*</label>
          <input type="datetime-local" id="LastShowDate" name="LastShowDate" value={formData.LastShowDate} onChange={handleInputChange} required />
        </div>

        <div>
          <label htmlFor="Status">Status*</label>
          <select id="Status" name="Status" value={formData.Status} onChange={handleInputChange}>
            <option value={false}>Inaktiv</option>
            <option value={true}>Aktiv</option>
          </select>
        </div>

        <button type="submit">UPPDATERA</button>
      </form>

      {updated && <p className="success-message">Nyhet är uppdaterad</p>}
    </div>
  );
};

export default UpdateForm;
